import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Loader from "react-loader-spinner";
import { FiDownload, FiInfo } from "react-icons/fi";
import { useTranslation } from "react-i18next";

// import * as jobsActions from "../../Redux/Actions/jobs";
import * as commonActions from "../../Redux/Actions/common";
import { toastMessage } from "../../utils/toast";
import { clearSession } from "../../utils/initiate";
import {
  getDocumentLabel,
  downloadFile,
  dateTimeFormat,
  getLocaleValue,
} from "../../utils";
import { initiateLogOut } from "../../utils/initiate";
import RefundModal from "../Ui/RefundModal/RefundModal";
import * as paymentActions from "../../Redux/Actions/payment";
import RefundDisclaimerModal from "../Ui/RefundDisclaimerModal/RefundDisclaimerModal";
import { downloadDocument, downloadVendorDocument, downloadZipDocument, getAdditionalPaymentDetail, getDocumentMetaData, getIndividual, getIndividualJob, getTransactionSummaryDetail, getVendorDocumentMetaData } from "../../Redux/Actions/jobs";
import { apiWrapWithErrorWithData } from "../../utils/apiWrapper";
// import PaymentSummaryModal from "../Ui/PaymentSummaryModal/paymentSummaryModal";

const JobDetail = ({ history, match }) => {
  const [data, setData] = useState([]);
  const [transactionData, setTransactionData] = useState([]);
  const [fileArr, setFileArr] = useState([]);
  const [vendorDocArr, setVendorDocArr] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentItems, setCurrentItems] = useState([]);
  const [refundable, setRefundable] = useState(false);
  const [zipLoading, setZipLoading] = useState(false);
  const [zipLoading1, setZipLoading1] = useState(false);
  const [timeLineCommentID, setTimeLineCommentID] = useState("");
  const [displayData, setDisplayData] = useState({});
  const ref = useRef();
  const { t } = useTranslation();
  const [showConfirmRefundModal, setShowConfirmRedundModal] = useState(false);
  const [showRefundModal, setShowRefundModal] = useState(false);
  const [showDisclaimerModal, setShowDisclaimerModal] = useState(false);
  const dispatch = useDispatch();
  const { jobID } = match.params;
  const userData = useSelector(({ User }) => User.data);
  const [balance, setBalance] = useState(0);
  const [refundDescription, setRefundDescription] = useState("");
  const [refundReasonId, setRefundReasonId] = useState(0);
  const [refundConfirmLoading, setRefundConfirmLoading] = useState(false);
  // const [totalAmount, setTotalAmount] = useState(0);
  const [additionalPaymentDetails, setAdditionalPaymentDetails] = useState([]);
  const [showpaymentSummaryDetails, setShowPaymentSummaryDetails] =
    useState(false);
  const [summaryDetailsLoading, setSummaryDetailsLoading] = useState(false);
  const [refundLoading, setRefundLoading] = useState(false);
  const [currency, setCurrency] = useState("");
  const [paymentId, setPaymentId] = useState(0);

  const jobDatas = useSelector(({ Job }) => Job.jobData);

  const singleJobData = jobDatas
    ?.filter((job) => job.id === Number(jobID))
    ?.pop();

  useEffect(() => {
    setLoading(true);
    apiWrapWithErrorWithData(getIndividual(jobID)).then((res)=>{
        if (res && res.data) {
          setLoading(false);
          setData(res.data);
          // setRefundable(res.data?.isRefundable);
          let tempFileArr = [];
          let documentArr =
            res.data.jobInfo.json &&
            JSON.parse(res.data.jobInfo.json) &&
            JSON.parse(res.data.jobInfo.json).documents;
          handleVendorDocuments(res.data.vendorDocuments);
          if (Object.entries(documentArr).length !== 0) {
            Object.entries(documentArr).map(
              ([key, value]) =>
                (value.length > 0 || value !== null) &&
              apiWrapWithErrorWithData(getDocumentMetaData(res.data.customerInfo.id, value)).then((res) => {
                    let documentData = res.data[0];
                    tempFileArr.push({ key, ...documentData });
                    tempFileArr.length === Object.entries(documentArr).length &&
                      setFileArr(tempFileArr);
                    setLoading(false);
                  })
                  .catch((err) => {
                    setLoading(false);
                    console.log("Unable to get documents meta data", err);
                    err?.response?.status === 401 &&
                      clearSession(dispatch, history);
                  })
            );
          }

          let newData = {};
          let job = res.data.jobInfo && JSON.parse(res.data.jobInfo.json).data;
          if (job === null || job === undefined) return;
          for (let [key, value] of Object.entries(job)) {
            if (!key.includes("+")) {
              newData = {
                [key.charAt(0).toUpperCase() + key.slice(1)]: value,
                ...newData,
              };
            } else {
              let fieldName = key.split(/\+/);
              if (typeof value === "boolean") {
                value = value === true ? "Yes" : "No";
              }
              if (typeof value === "object") {
                for (let [key1, value1] of Object.entries(value)) {
                  if (key1 === "address") {
                    newData = {
                      [fieldName[0] +
                      " " +
                      key1.charAt(0).toUpperCase() +
                      key1.slice(1)]: value1,
                      ...newData,
                    };
                  }
                }
              }
              if (!(typeof value === "object"))
                newData[key.includes("+") ? fieldName[0] : key] = value;
            }
          }
          setDisplayData(newData);
        } else {
          setLoading(false);
          toastMessage(
            "error",
            (res && res.message) || `Unable to get the job info`
          );
        }
      })
      .catch((err) => {
        setLoading(false);
        err?.response?.status === 401 && clearSession(dispatch, history);
      });

    apiWrapWithErrorWithData(getTransactionSummaryDetail(jobID)).then((res) => {
        if (res?.data) {
          const summary = res.data?.summary;
          setTransactionData(res.data);
          // setTotalAmount((res?.data.totalAmount).toFixed(1));
          setBalance((res?.data.totalBalanceAmount).toFixed(1));
          setCurrency(res?.data.currency);
          const summayData = summary.map(({ amount, summary }) => {
            return {
              amount: amount.toFixed(1),
              summary: getLocaleValue(summary),
            };
          });
          setCurrentItems(summayData);
        }
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          initiateLogOut(userData.UserId, dispatch, history);
          toastMessage("error", `Access Denied`);
        } else {
          toastMessage(
            "error",
            `Unable to get the transaction summary details `
          );
        }
      });
    apiWrapWithErrorWithData(getAdditionalPaymentDetail(jobID)).then((res) => {
        if (res?.data) {
          let paymentDetails = res?.data?.map(
            ({ id, typeName, status, totalAmount }) => {
              return {
                id,
                amount: totalAmount.toFixed(2),
                typeName,
                status,
              };
            }
          );
          setAdditionalPaymentDetails(paymentDetails);
        }
      }).catch((err) => {
        if (err.response?.status === 401) {
          initiateLogOut(userData.UserId, dispatch, history);
          toastMessage("error", `Access Denied`);
        } else {
          toastMessage(
            "error",
            `Unable to get additional payment summary details `
          );
        }
      });
  }, [history, jobID]);

  let jobData = data.jobInfo && JSON.parse(data.jobInfo.json);
  
  const handleDownloadDocument = (documentID) => {
    apiWrapWithErrorWithData(downloadDocument(data.customerInfo.id, documentID)).then((res) => {
        res && downloadFile(res);
      })
      .catch((err) => {
        console.log("Something Went Wrong", err);
        err?.response?.status === 401 && clearSession(dispatch, history);
      });
  };

  const handleDownloadVendorDocument = (documentID) => {
    apiWrapWithErrorWithData(downloadVendorDocument(documentID)).then((res) => {
        res && downloadFile(res)   
      }).catch((err) => {
        console.log("Something Went Wrong", err);
        err?.response?.status === 401 && clearSession(dispatch, history);
      });
  };

  const handleDownloadAllDocument = (type) => {
    let docArr = [];
    if (type === "vendor") {
      setZipLoading1(true);
      docArr = vendorDocArr.map(({ documentId }) => ({
        documentId,
        userId: 2,
      }));
    } else {
      setZipLoading(true);
      docArr = fileArr.map(({ documentId }) => ({
        documentId,
        userId: data.customerInfo.id,
      }));
    }
    apiWrapWithErrorWithData(downloadZipDocument(docArr))
      .then((res) => {
        res && downloadFile(res, jobID, type);
        setZipLoading(false);
        setZipLoading1(false);
      })
      .catch((err) => {
        toastMessage(
          "error",
          (err && err.message) || "Unable to download all documents"
        );
        err?.response?.status === 401 && clearSession(dispatch, history);
      });
  };

  const handleVendorDocuments = (documents) => {
    let tempFileArr = [];
    if (documents) {
      documents.map(
        (value) =>
          (value.length > 0 || value !== null) &&
      apiWrapWithErrorWithData(getVendorDocumentMetaData(value))
            .then((res) => {
              let documentData = res.data[0];
              tempFileArr.push(documentData);
              tempFileArr.length === documents.length &&
                setVendorDocArr(tempFileArr);
              dispatch(commonActions.pageLoading(false));
            })
            .catch((err) => {
              dispatch(commonActions.pageLoading(false));
              console.log("Unable to get vendor documents meta data", err);
              err?.response?.status === 401 && clearSession(dispatch, history);
            })
      );
    }
  };

  const makeRefund = () => {
    setRefundDescription("");
    setRefundReasonId(0);
    setRefundConfirmLoading(true);
    const payload = {
      jobId: jobID,
      refundDescription,
    };
    paymentActions
      .paymentRefundRequestCreate(payload)
      .then((res) => {
        if (res && res.status === 200) {
          toastMessage("success", "Refund Request Created Successfully");
          setRefundConfirmLoading(false);
          window.location.reload();
        } else if (res && res.status === 400) {
          setRefundConfirmLoading(false);
          toastMessage("error", "Request Creation failed");
        } else {
          toastMessage("error", "Request Creation failed");
          setRefundConfirmLoading(false);
        }
        setShowDisclaimerModal(false);
      })
      .catch((err) => {
        setShowDisclaimerModal(false);
        setRefundConfirmLoading(false);
        toastMessage(
          "error",
          err?.response?.message ||
            err?.response?.data.data.validations[0] ||
            "Unable to make Refund Request"
        );
        err?.response?.status === 401 && clearSession(dispatch, history);
        // toastMessage('error', err?.response?.data.data.validations[0]);
      });
  };

  return (
    <div className="container-fluid">
      <div marginBottom="10px">
        <div className="my-4">
          <span
            className="card-label font-weight-bolder c-pointer"
            onClick={() => history.push("/jobs")}
          >
            {t("jobsManagement.infoJob.manageJobs")}
          </span>
          <span className="card-label font-weight-bolder mx-2">/</span>
          <span className="card-label font-weight-bolder text-dark">
            {jobID}
          </span>
        </div>
        {loading || refundLoading ? (
          <div className="d-flex align-items-center justify-content-center h-75vh">
            <Loader
              type="ThreeDots"
              color="#2d207d"
              height={40}
              width={40}
              style={{ textAlign: "center" }}
            />
          </div>
        ) : (
          <div>
            <div className="row col-lg-12" style={{ marginTop: "30px" }}>
              <div className="col-lg-8">
                <div className="card card-custom card-stretch gutter-b">
                  <div className="card-header border-0 d-flex justify-content-between">
                    <h3 className="card-title font-weight-bolder text-dark">
                      {t("jobsManagement.infoJob.customerInfo.title")}
                    </h3>
                  </div>
                  {data.jobInfo && (
                    <div className="card-body pt-0 pb-3">
                      <div
                        className="form-group fv-plugins-icon-container"
                        style={{
                          marginBottom: "10px",
                          paddingBottom: "5px",
                          borderBottom: "1px solid #f1f5fa",
                        }}
                      >
                        <span className="text-muted">
                          {t("jobsManagement.infoJob.customerInfo.id")} :{" "}
                        </span>{" "}
                        <label> {data.jobInfo.jobId} </label>
                      </div>
                      <div
                        className="form-group fv-plugins-icon-container"
                        style={{
                          marginBottom: "10px",
                          paddingBottom: "5px",
                          borderBottom: "1px solid #f1f5fa",
                        }}
                      >
                        <span className="text-muted">
                          {t("jobsManagement.infoJob.customerInfo.dateTime")} :{" "}
                        </span>{" "}
                        <label> {data.jobInfo.date} </label>
                      </div>
                      <div
                        className="form-group fv-plugins-icon-container"
                        style={{
                          marginBottom: "10px",
                          paddingBottom: "5px",
                          borderBottom: "1px solid #f1f5fa",
                        }}
                      >
                        <span className="text-muted">
                          {t("jobsManagement.infoJob.customerInfo.user")} :{" "}
                        </span>{" "}
                        {data.customerInfo.name}
                      </div>
                      <div
                        className="form-group fv-plugins-icon-container"
                        style={{
                          marginBottom: "10px",
                          paddingBottom: "5px",
                          borderBottom: "1px solid #f1f5fa",
                        }}
                      >
                        <span className="text-muted">
                          {t("jobsManagement.infoJob.customerInfo.department")}{" "}
                          :{" "}
                        </span>{" "}
                        {data.jobInfo.departmentName}
                      </div>
                      <div
                        className="form-group fv-plugins-icon-container"
                        style={{
                          marginBottom: "10px",
                          paddingBottom: "5px",
                          borderBottom: "1px solid #f1f5fa",
                        }}
                      >
                        <span className="text-muted">
                          {t(
                            "jobsManagement.infoJob.customerInfo.masterProcess"
                          )}{" "}
                          :{" "}
                        </span>{" "}
                        {data.jobInfo.masterProcessName}
                      </div>
                      <div
                        className="form-group fv-plugins-icon-container"
                        style={{
                          marginBottom: "10px",
                          paddingBottom: "5px",
                          borderBottom: "1px solid #f1f5fa",
                        }}
                      >
                        <span className="text-muted">
                          {t("jobsManagement.infoJob.customerInfo.process")} :{" "}
                        </span>{" "}
                        {data.jobInfo.processName}
                      </div>

                      <hr className="hr-dashed" />
                      <div className="form-group fv-plugins-icon-container">
                        <h3 className="card-title font-weight-bolder text-dark">
                          {t("jobsManagement.infoJob.jobInfo.title")}
                        </h3>
                        <div className="mt-2">
                          {Object.entries(displayData).length === 0 ? (
                            <p className="text-muted text-center">
                              {t("jobsManagement.noDataAvailable")}
                            </p>
                          ) : (
                            Object.entries(displayData).map(([key, value]) => (
                              <p
                                className="form-group fv-plugins-icon-container"
                                style={{
                                  marginBottom: "10px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #f1f5fa",
                                }}
                                key={key}
                              >
                                <span className="text-muted">{t(key)} : </span>{" "}
                                <label> {value} </label>{" "}
                              </p>
                            ))
                          )}
                        </div>
                      </div>          
                      <hr className="hr-dashed" />
                      <div className="form-group fv-plugins-icon-container">
                        <div className="d-flex justify-content-between">
                          <h3 className="card-title font-weight-bolder text-dark">
                            {t("jobsManagement.infoJob.documents")}
                          </h3>
                          {fileArr.length !== 0 && (
                            <button
                              disabled={zipLoading}
                              className="btn btn-primary d-flex align-items-center"
                              onClick={handleDownloadAllDocument}
                            >
                              {t("jobsManagement.infoJob.downloadAll")}
                              {zipLoading && (
                                <Loader
                                  type="Oval"
                                  color="#fff"
                                  height={20}
                                  width={20}
                                  style={{ marginLeft: "10px" }}
                                />
                              )}
                            </button>
                          )}
                        </div>
                        <div className="mt-1 d-flex flex-wrap">
                          {Object.entries(jobData).length === 0 ? (
                            <p className="text-muted text-center">
                              {t("jobsManagement.noDataAvailable")}
                            </p>
                          ) : fileArr.length === 0 ? (
                            <p className="text-muted text-center">
                              {t("jobsManagement.noDataAvailable")}
                            </p>
                          ) : (
                            fileArr.map(
                              ({ key, thumbnailUri, fileName, documentId }) => {
                                let imgType =
                                  fileName &&
                                  (fileName.includes("png") ||
                                    fileName.includes("jpeg") ||
                                    fileName.includes("jpg"));
                                return (
                                  <div
                                    key={fileName}
                                    className="document font-weight-bold my-2 me-2"
                                  >
                                    <div
                                      style={{
                                        width: "-webkit-fill-available",
                                        height: "-webkit-fill-available",
                                        margin: "0 auto",
                                      }}
                                    >
                                      {imgType ? (
                                        <img
                                          src={thumbnailUri}
                                          alt="Thumbnail"
                                          width="100%"
                                          height="100%"
                                        />
                                      ) : (
                                        <img
                                          src={"/Assets/nopreview_all.png"}
                                          alt="Thumbnail"
                                          style={{
                                            width: "200px",
                                            height: "150px",
                                          }}
                                        />
                                      )}
                                    </div>
                                    <div
                                      className="d-flex align-items-center justify-content-between position-absolute bottom-0 bg-white p-2 "
                                      style={{ width: "100%" }}
                                    >
                                      <p className="m-0">
                                        {getDocumentLabel(key, true)}
                                      </p>
                                      <FiDownload
                                        onClick={() =>
                                          handleDownloadDocument(documentId)
                                        }
                                        className="c-pointer"
                                      />
                                    </div>
                                  </div>
                                );
                              }
                            )
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div className="col-lg-12 card">
                  {" "}
                  {/*VendorDoc*/}
                  <div className="card-body form-group fv-plugins-icon-container mb-0">
                    <div className="d-flex justify-content-between">
                      <h3 className="card-title font-weight-bolder text-dark">
                        {t("jobsManagement.infoJob.vendorDocuments")}
                      </h3>
                      {fileArr.length !== 0 && vendorDocArr.length !== 0 && (
                        <button
                          disabled={zipLoading1}
                          className="btn btn-primary d-flex align-items-center"
                          onClick={() => handleDownloadAllDocument("vendor")}
                        >
                          {t("jobsManagement.infoJob.downloadAll")}
                          {zipLoading1 && (
                            <Loader
                              type="Oval"
                              color="#fff"
                              height={20}
                              width={20}
                              style={{ marginLeft: "10px" }}
                            />
                          )}
                        </button>
                      )}
                    </div>
                    <div className="mt-1 d-flex flex-wrap">
                      {vendorDocArr.length === 0 ? (
                        <p className="text-muted text-center">
                          {t("jobsManagement.noDataAvailable")}
                        </p>
                      ) : (
                        vendorDocArr.map(
                          ({ fileName, thumbnailUri, documentId }) => {
                            return (
                              <div
                                key={documentId}
                                className="document font-weight-bold my-2 me-2"
                              >
                                <div
                                  style={{
                                    width: "-webkit-fill-available",
                                    height: "-webkit-fill-available",
                                    margin: "0 auto",
                                  }}
                                >
                                  {thumbnailUri !== null ? (
                                    <img
                                      src={thumbnailUri}
                                      alt="Thumbnail"
                                      width="100%"
                                      height="100%"
                                    />
                                  ) : (
                                    <img
                                      src={"/Assets/nopreview.png"}
                                      alt="Thumbnail"
                                      style={{
                                        width: "200px",
                                        height: "150px",
                                      }}
                                    />
                                  )}
                                </div>
                                <div
                                  className="d-flex align-items-center justify-content-between position-absolute bottom-0 bg-white p-2 "
                                  style={{ width: "100%" }}
                                >
                                  <p className="m-0">
                                    {getDocumentLabel(fileName, true)}
                                  </p>
                                  <FiDownload
                                    onClick={() =>
                                      handleDownloadVendorDocument(documentId)
                                    }
                                    className="c-pointer"
                                  />
                                </div>
                              </div>
                            );
                          }
                        )
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-lg-12 card">
                  <div className="card-body form-group fv-plugins-icon-container mb-0">
                    <div className="d-flex justify-content-between">
                      <h3 className="card-title font-weight-bolder text-dark">
                        {getLocaleValue("job_details_description_title")}
                      </h3>
                      {refundable && (
                        <button
                          className="btn btn-primary d-flex align-items-center"
                          onClick={() => {
                            setShowDisclaimerModal(true);
                          }}
                        >
                          {"Refund"}
                        </button>
                      )}
                    </div>
                    <div className="mt-1 d-flex flex-wrap">
                      <table className="table tableFreez tablefix table-head-custom table-vertical-center table-head-bg">
                        <tbody>
                          {currentItems.map(({ sno, summary, amount }) => {
                            return (
                              <tr key={sno}>
                                <td>
                                  <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                    {t(summary)}
                                  </span>
                                </td>

                                <td>
                                  <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                    {amount}
                                  </span>
                                </td>
                              </tr>
                            );
                          })}
                          <tr>
                            <td>
                              <span style={{ fontWeight: 500 }}>
                                {getLocaleValue("job_details_balance")}
                              </span>
                            </td>
                            <td>
                              <span style={{ fontWeight: 500 }}>
                                {`${balance} ${currency}`}{" "}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12 card">
                  <div className="card-body form-group fv-plugins-icon-container mb-0">
                    <div className="d-flex justify-content-between">
                      <h3 className="card-title font-weight-bolder text-dark">
                        {getLocaleValue("Additional_payment_summary")}
                      </h3>
                    </div>
                    <div className="mt-1 d-flex flex-wrap">
                      <table className="table tableFreez tablefix table-head-custom table-vertical-center table-head-bg">
                        <tbody>
                          {additionalPaymentDetails &&
                          additionalPaymentDetails.length === 0 ? (
                            <p className="text-muted">
                              {t("jobsManagement.noDataAvailable")}
                            </p>
                          ) : (
                            additionalPaymentDetails.map(
                              ({ id, typeName, amount, status }, i) => {
                                return (
                                  <tr key={i}>
                                    <td>
                                      <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                        {typeName}
                                      </span>
                                      <span
                                        className="text-dark-75 font-weight-bolder d-block font-size-lg"
                                        style={{ fontWeight: 500 }}
                                      >
                                        {status}
                                      </span>
                                    </td>

                                    <td>
                                      <div className="d-flex justify-content-center">
                                        <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                          {amount}
                                        </span>
                                        <div className="position-relative ms-2">
                                          <FiInfo
                                            className="c-pointer font-20 me-lg-2"
                                            onClick={() => {
                                              setShowPaymentSummaryDetails(
                                                true
                                              );
                                              setPaymentId(id);
                                              setSummaryDetailsLoading(true);
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                );
                              }
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="card">
                  <div className="card-header border-0">
                    <h4 className="card-title">
                      {t("jobsManagement.infoJob.statusInfo")}
                    </h4>
                  </div>
                  <div className="card-body">
                    <div className="slimscroll">
                      <div className="activity">
                        {transactionData.stausInfo &&
                        transactionData.stausInfo.length === 0 ? (
                          <p className="text-muted text-center">
                            {t("jobsManagement.noDataAvailable")}
                          </p>
                        ) : (
                          transactionData.stausInfo &&
                          transactionData.stausInfo.map(
                            ({ logData, time }, index) => {
                              let parsedLogData = JSON.parse(logData);
                              return (
                                <div className="activity-info" key={index}>
                                  <div className="icon-info-activity">
                                    <i className="fst-normal las la-check-circle bg-soft-primary">
                                      {index + 1}
                                    </i>
                                  </div>
                                  <div className="activity-info-text">
                                    <div className="d-flex flex-column align-items-start">
                                      <div className="d-flex">
                                        <p className="d-flex align-items-center badge badge-soft-primary">
                                          {parsedLogData.ToStatus}
                                        </p>
                                        <div className="position-relative ms-2">
                                          {timeLineCommentID === index && (
                                            <div
                                              ref={ref}
                                              className="popover position-absolute fade show bs-popover-start"
                                              style={{
                                                top: "-90px",
                                                width: "300px",
                                                left: "-270px",
                                              }}
                                            >
                                              {" "}
                                              <img
                                                src="/Assets/remove.svg"
                                                height={"15px"}
                                                width={"15px"}
                                                style={{
                                                  cursor: "pointer",
                                                  position: "relative",
                                                  right: "-250px",
                                                  top: "10px",
                                                }}
                                                onClick={() => {
                                                  setTimeLineCommentID("");
                                                }}
                                              />
                                              <p
                                                className="m-0 p-3 popover-body"
                                                dangerouslySetInnerHTML={{
                                                  __html:
                                                    parsedLogData.Commments,
                                                }}
                                              />
                                            </div>
                                          )}
                                          <FiInfo
                                            className="c-pointer font-20 me-lg-2"
                                            onClick={() =>
                                              setTimeLineCommentID(
                                                timeLineCommentID === index
                                                  ? ""
                                                  : index
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                      <p className="text-muted font-11 mt-1">
                                        {dateTimeFormat(time)}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          )
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {showRefundModal && (
        <RefundModal
          t={t}
          handleCancel={() => {
            setShowRefundModal(false);
            setShowDisclaimerModal(true);
            setRefundDescription("");
            setRefundReasonId(0);
          }}
          history={history}
          match={match}
          showModal={showRefundModal}
          setConfirmModal={setShowConfirmRedundModal}
          footerOption1={getLocaleValue("refund_confirm_btn")}
          footerOption2={getLocaleValue("refund_cancel_btn")}
          description={refundDescription}
          setDescription={setRefundDescription}
          reasonId={refundReasonId}
          setReasonId={setRefundReasonId}
          handleOk={() => {
            setShowConfirmRedundModal(true);
            setShowRefundModal(false);
          }}
          type={"refund"}
        >
          {" "}
        </RefundModal>
      )}
      {showDisclaimerModal && (
        <RefundDisclaimerModal
          t={t}
          handleCancel={() => {
            setShowDisclaimerModal(false);
            setRefundDescription("");
            setRefundReasonId(0);
          }}
          history={history}
          match={match}
          handleOk={() => {
            setShowRefundModal(true);
            setShowDisclaimerModal(false);
          }}
          showModal={showDisclaimerModal}
          footerOption1={getLocaleValue("refund_confirm_btn")}
          footerOption2={getLocaleValue("refund_cancel_btn")}
          type={"disclaimer"}
        >
          {" "}
        </RefundDisclaimerModal>
      )}
      {showConfirmRefundModal && (
        <RefundDisclaimerModal
          t={t}
          handleCancel={() => {
            setShowConfirmRedundModal(false);
            setShowRefundModal(true);
          }}
          history={history}
          match={match}
          handleOk={makeRefund}
          showModal={showConfirmRefundModal}
          footerOption1={getLocaleValue("refund_confirm_btn")}
          footerOption2={getLocaleValue("refund_cancel_btn")}
          loading={refundConfirmLoading}
        >
          {" "}
        </RefundDisclaimerModal>
      )}
    </div>
  );
};

export default JobDetail;
